import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, Typography } from "@material-ui/core";
import { useStyles } from "../../Forms/EditPointsBalance/styles";
import clsx from "clsx";
import EditPointsBalanceForm from "../../Forms/EditPointsBalance";
import Title from "../../Title";
import ColoredLine from "../../ColoredLine";

export default function EditPointsBalanceModal({
  open,
  onClose,
  currentPoints,
  onSubmitPoints,
  accessHolderID,
  accessHolderName,
}) {
  const classes = useStyles();

  return (
    <Dialog
      className={classes.editDialog}
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={onClose}
    >
      <DialogContent className="edit-points-balance">
        <div className={clsx("header", classes.header)}>
          <Title variant="h5" className={clsx("points-balance-title")} noGutter>
            Edit Point Balance
          </Title>
          <Typography variant="h5" align="right">
            {currentPoints ?? 0} Pts
          </Typography>
        </div>
        <ColoredLine />
        <Typography variant="subtitle1" align="right" className={classes.currentLabel}>
          Current
        </Typography>
        <EditPointsBalanceForm
          toggleModal={onClose}
          currentPoints={currentPoints ?? 0}
          onSubmitPoints={onSubmitPoints}
          accessHolderID={accessHolderID}
          accessHolderName={accessHolderName}
        />
      </DialogContent>
    </Dialog>
  );
}

EditPointsBalanceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentPoints: PropTypes.number,
  onSubmitPoints: PropTypes.func,
  accessHolderID: PropTypes.string,
  accessHolderName: PropTypes.shape({
    first: PropTypes.string,
    last: PropTypes.string,
  }),
};
